export default __webpack_public_path__ + "static/media/pw-add-form-1.dfd77a32.jpg";